$(document).ready(function() {
    
    document.querySelectorAll('.js-toggleCalendar').forEach(field => {
    field.addEventListener('click', () => {
        if ( document.querySelector('.home-widget-calendar') ) document.querySelector('.home-widget-calendar').classList.toggle('active');
    });
    });

    const lbw_bookingDateFormat =  'yy-mm-dd';
    const lbw_displayDateFormat =  (typeof lbw_customDisplayDateFormat === 'string') ? lbw_customDisplayDateFormat : lbw_bookingDateFormat;
    let start 	= $('#home-checkin-alt').attr('value'),
    end 	= $('#home-checkout-alt').attr('value'),
    op 		= 0;

    const dates_range = function(date1, date2) { 
    const dt1 = new Date(date1);
    const dt2 = new Date(date2);
    return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) ) /(1000 * 60 * 60 * 24));
    }

    const calendarBeforeShow = date => {
        if ( start !== undefined ){
            let startDate = $.datepicker.parseDate(lbw_bookingDateFormat, start);
            let endDate = $.datepicker.parseDate(lbw_bookingDateFormat, end);
            if ( date.getTime() == startDate.getTime() ) {
                return[ true, 'ui-datepicker-startday' ];
            } else {
            if ( date.getTime() == endDate.getTime() ) {
                //document.querySelector('.home-widget-calendar').classList.remove('active');
                return[ true, 'ui-datepicker-endday' ];
            } else {
                if( date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime() ){
                return[ true, 'ui-datepicker-daysrange' ];
                } else {
                return[ true ];
                }
            }
            }
        } else{
            return[ true ];
        }
    };

    const calendarOnSelect = date => {
    start = (start !== undefined) ? start : $.datepicker.formatDate(lbw_bookingDateFormat, new Date());
    let startDate = $.datepicker.parseDate(lbw_bookingDateFormat, start);
    let selectedDate = $.datepicker.parseDate(lbw_bookingDateFormat, date);
    
    if ( op === 0 ) {
        op = 1;
        start = date;
        end =  date;  
    } else {
        op = 0;
        if(selectedDate <= startDate){
        end = start;
        start = date;  
        } else {
        end =  date; 
        }
    }

    const startDispaly = $.datepicker.formatDate( lbw_displayDateFormat, $.datepicker.parseDate(lbw_bookingDateFormat, start) );
    const endDisplay = $.datepicker.formatDate( lbw_displayDateFormat, $.datepicker.parseDate(lbw_bookingDateFormat, end) );

    $('#home-checkin-alt').attr('value',start);
    $('#home-checkout-alt').attr('value',end);

    $('#lpw-checkin').attr('value',startDispaly);
    $('#lpw-checkout').attr('value',endDisplay);
    };

    const calendarOptions = {
        minDate: new Date("2024-06-09"),
        numberOfMonths: 2,
        dateFormat: lbw_bookingDateFormat,
        beforeShowDay: calendarBeforeShow,
        onSelect: calendarOnSelect
    };
    $('.home-widget-calendar').datepicker( calendarOptions );
}); 